<template>
  <div>
    <!-- 运行日汇总 -->
    <!-- 查询 -->
    <div :style="{'display':'flex','align-items': search_align_items, 'text-align':'right','flex-direction':search_flex_direction}">
      <summaryLevel @getLevel="getLevel" style="flex:1;margin-right:8px" :DealOptions="DealOptions" :mulSelectLoading="mulSelectLoading"></summaryLevel>
      <quickQuery  :isMounted="true" @handleQuery="handleQuery" @quickQuery="quickQuery" @download="download" @searchType="getSearchType" :downloading="downloading" style="text-align: right"></quickQuery>
    </div>
    <!-- 表格 -->
    <div  class="page_container_a">
      <!-- <div class="page_table"> -->
        <el-table class="page_table" :id="'table'+queryType"
          :data="dataList" 
          :size="size" 
          border 
          :span-method="objectSpanMethod" 
          :cell-style="cellStyle"
          v-loading="loading"
        >
          <!-- :show-summary="showSum" 
          :summary-method="getSummaries" -->
          <!-- @sort-change='sortChange' sortable="custom"  -->
          <el-table-column :label="$t('runState.groupName')" align="center" min-width="150" prop="groupName" fixed="left"  class-name="fixd"></el-table-column>
          <el-table-column :label="$t('runState.statDate')" align="center" min-width="120" prop="statDate" fixed="left"  class-name="fixd" v-if="queryType != 2"></el-table-column>
          <el-table-column :label="$t('runState.runDuration')" align="center" min-width="120" prop="runduration">
            <template slot-scope="scope">{{fixed2(scope.row.runduration)}}</template>
          </el-table-column>
          <el-table-column :label="$t('runState.driveDuration')" align="center" min-width="120" prop="driveDuration">
            <template slot-scope="scope">{{fixed2(scope.row.driveDuration)}}</template>
          </el-table-column>
          <el-table-column :label="$t('runState.idleDuration')" align="center" min-width="120" prop="idleDuration">
            <template slot-scope="scope">{{fixed2(scope.row.idleDuration)}}</template>
          </el-table-column>
          <el-table-column :label="$t('runState.idleMileage')" align="center" min-width="120" prop="idleMileage"></el-table-column>
          <el-table-column :label="$t('runState.idleOilConsume')" align="center" min-width="120" prop="idleOilConsume"></el-table-column>
          <el-table-column :label="$t('driver.runMileage')" align="center" min-width="120" prop="runMileage">
            <template slot-scope="scope">{{fixed2(scope.row.runMileage)}}</template>
          </el-table-column>
          <el-table-column :label="$t('runState.perOilConsume')" min-width="150" align="center" prop="perOilConsume"></el-table-column>
          <el-table-column :label="$t('runState.oilConsume')" align="center" min-width="120" prop="oilConsume"></el-table-column>
          <el-table-column :label="$t('runState.elecConsume')" align="center" min-width="110" prop="elecConsume"></el-table-column>
          <el-table-column :label="$t('runState.perElecConsume')" align="center" min-width="120" prop="perElecConsume">
            <template slot-scope="scope">{{fixed2(scope.row.perElecConsume)}}</template>
          </el-table-column>
          
        </el-table>
      <!-- </div> -->
    </div>
    <!-- 分页 -->
    <div>
      <kl-pagination  :total="total" @current-change="pageChange" :pageSize="pageSize" :currentPage="currentPage"></kl-pagination>
    </div>
  </div>
</template>
<script>
import quickQuery from '../components/generalOrQuickQuery.vue'
import summaryLevel from '@/views/statistics/operationalData/components/summaryLevel'
import language from '@/utils/getLanguageId'
import { mapState } from "vuex";
export default {
  props:{
    size:{
      type:String,
    },
    DealOptions:{
      type:Array,
      default:function () {
        return [] 
      }
    },
    mulSelectLoading:{
      type:Boolean,
      default:false,
    },
    queryType:{
      type:Number,
      default:0,
    },
    isClicked:{
      type: Boolean,
      default:false,
    }
  },
  components:{summaryLevel,quickQuery},
  data(){
    return{
      downloading:false,
      vehicles:"",
      loading:false,
      dataList:[],
      tableWidth:undefined,
      total:0,
      pageSize:10,
      currentPage:1,
      showSum:true,
      level:0,
      selectLevel:"",
      form:undefined,
      needMergeArr: ["groupName", "statDate"], 
      rowMergeArrs: [],
      search_align_items: "center",
      search_flex_direction: "row",
      LanguageId:1,
    }
  },
  computed:{
    ...mapState({
        operator: (state) => state.user.operator,
        selectedVehicles: state => state.app.vehicles.selectedVehicles,
        sidebar_opened: state => state.app.sidebar.opened,
    }),
  },
  watch: {
    // // 合并合计行的合计
    // dataList: {// 表格数据
    //   immediate: true,
    //   handler() {
    //     setTimeout(() => {
    //       let tds;
    //       switch(this.queryType){
    //         case 0:
    //           tds = document.querySelectorAll('#table0 .el-table__fixed-footer-wrapper tr>td');//表格有固定列时 写法
    //           if(tds.length > 0){
    //             tds[0].colSpan = 2;
    //             tds[0].style.textAlign = 'center'
    //             tds[0].style.background = '#E8F0FF'
    //             tds[1].style.display = 'none'
    //           }
    //           break;
    //         case 1:
    //           tds = document.querySelectorAll('#table1 .el-table__fixed-footer-wrapper tr>td');//表格有固定列时 写法
    //           // console.log(tds);
    //           if(tds.length > 0 && tds[1] != undefined){
    //             tds[0].colSpan = 2;
    //             tds[0].style.textAlign = 'center'
    //             tds[0].style.background = '#E8F0FF'
    //             tds[1].style.display = 'none'
    //           }
    //           break;
    //         case 2:
    //           tds = document.querySelectorAll('#table2 .el-table__fixed-footer-wrapper tr>td');//表格有固定列时 写法
    //           if(tds.length > 0 && tds[20] != undefined){
    //             tds[20].style.background = '#E8F0FF'
    //           }
    //           break;
    //       }
    //       // const tds = document.querySelectorAll('#table .el-table__footer-wrapper tr>td');//表格没有固定列时 写法
    //       // const tds = document.querySelectorAll('#table' + this.queryType + ' .el-table__fixed-footer-wrapper tr>td');//表格有固定列时 写法
    //       // console.log(tds);
    //     }, 0)
    //   }
    // },
    total(newVal){
      this.showSum = newVal > 1 ? true : false;
    },
    // tabs点击才进行初次加载
    isClicked(newVal){
      if(newVal){
        this.getList();
      }
    },
    //英语版时调整UI
    LanguageId(newVal){
      if(this.LanguageId == 3){
        this.search_align_items = "";
        this.search_flex_direction = "column";
      }else{
        this.search_align_items = "center";
        this.search_flex_direction = "row";
      }
    },
    sidebar_opened(newVal){
      newVal ? this.getWidth() : null
    }
  },
  methods:{
    getSearchType(val){
      this.quickQueryType = val;
    },
    fixed2(val){
      if(val == 0 || val == null || val == undefined || val == ""){
        return 0;
      }
      if(Number.isInteger(val)) return val;
      debugger;
      return val.toFixed(2)
    },
    getSelectedVehicles(){
      this.vehicles = "";
      for(let k = 0; k < this.selectedVehicles.length; k++){
        if(this.selectedVehicles[k].treeLevel == 5){
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0,this.vehicles.length-1);
    },
    // 给单元格添加背景色
    cellStyle({row,columnIndex}){
      switch(this.queryType){
        case 0:
          if(columnIndex == 0 || columnIndex == 1){
            return 'background:rgb(238, 244, 255)'
          }
          break;
        case 1:
          if(columnIndex == 0 || columnIndex == 1){
            return 'background:rgb(238, 244, 255)'
          }
          break;
        case 2:
          if(columnIndex == 0){
            return 'background:rgb(238, 244, 255)'
          }
          break;
      }
    },
    getList(){
      this.loading = true;
      this.$api.summaryInfo({
        // vehicles: "",
        queryType: this.queryType,
        beginDate: this.form.beginDate,
        endDate: this.form.endDate,
        level: this.selectLevel,
        OperatorID: this.operator.OperatorId + "",
        PageNo: this.currentPage,
        PageSize: 10,
        IsExport: 0, // 0是查询 1是下载
        Language: this.LanguageId,
      })
      .then((res)=>{
        if(res && res.code == 200){
          this.dataList = res.data;
          this.total = res.count;
          this.loading = false;
        }
      })
      .catch((e)=>{
        this.loading = false;
        this.dataList = [];
        this.total = 0;
      })
    },
    // 分页
    pageChange(page) {
      this.currentPage = page;
      this.getList();
    },
    // 排序
    sortChange(column){
      // console.log("排序", column.prop, column.order);
      // this.currentPage = 1; // 排序后返回第一页
      this.dataList = this.dataList.sort(
        this.SortFun(column.prop, column.order === "descending")
      );
    },
    SortFun(attr, rev) {
      // console.log(rev)
      //第一个参数传入的prop表示排的是哪一列，第二个参数是升还是降排序
      if (rev == undefined) {
        rev = 1;
      } else {
        rev = rev ? 1 : -1;
        //rev = rev>0 ? 1 : -1;
      }
      return function (a, b) {
        a = a[attr];
        b = b[attr];
        // console.log(a,b);
        if (a < b) {
          return rev * -1;
        }
        if (a > b) {
          return rev * 1;
        }
        return 0;
      };
    },

    // 合计行计算全部数据而不是当页合计
    getSummaries(param){
      let data = this.dataList;

      // console.log(param);
      const { columns} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = this.$t("runState.tableSum");
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        sums[index] = values.reduce((prev, curr) => {
          const value = Number(curr);
          if (!isNaN(value)) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);
        if(!Number.isInteger(sums[index])){
          sums[index] = sums[index].toFixed(2);
        }
      });

      return sums;
      
    
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }){
      if (columnIndex === 0) {
        if (rowIndex % this.dataList.length === 0) {
          return {
            rowspan: this.dataList.length,
            colspan: 1
          };
        }else {
            return {
              rowspan: 0,
              colspan: 0
            };
        }
      }
    },
    getLevel(level){
      // console.log(level,"----------------------");
      this.level = level;
      if(this.level.isFirst){  // 汇总级别初始化完成时，查询数据。
        this.handleQuery(this.form);
      }
    },
    quickQuery(val){
      this.form = val;
      if(this.level.isAll && this.level.mulSelecteds.length >1){
        this.level.mulSelecteds.shift();
        this.selectLevel = this.level.mulSelecteds.join(",");
      }else if(Array.isArray(this.level.mulSelecteds)){
        this.selectLevel = this.level.mulSelecteds.join(",");
      }else{
        this.selectLevel = this.level.mulSelecteds;
      }
      // this.vehicles = this.getSelectedVehicles();
      if((this.selectLevel == "" || this.selectLevel == undefined) && !this.mulSelectLoading){
        this.$message({
          message: this.$t("runState.select_search_level"),//'请选择汇总级别',
          type: 'warning'
        });
        return ;
      }
      if(this.form.beginDate == "" || this.form.beginDate == null || this.form.beginDate == undefined){
        this.$message({
          message: this.$t("runState.select_search_date"),//'请选择查询时间',
          type: 'warning'
        });
        return ;
      }
      if(this.selectLevel){  // 汇总级别有数据时，进行数据查询。
        this.currentPage = 1;
        this.getList();
      }
    },
    handleQuery(val){
      this.form = val;
      // console.log(this.level);return;
      if(this.level.isAll && this.level.mulSelecteds.length >1){
        this.level.mulSelecteds.shift();
        this.selectLevel = this.level.mulSelecteds.join(",");
      }else if(Array.isArray(this.level.mulSelecteds)){
        this.selectLevel = this.level.mulSelecteds.join(",");
      }else{
        this.selectLevel = this.level.mulSelecteds;
      }
      // this.vehicles = this.getSelectedVehicles();
      if((this.selectLevel == "" || this.selectLevel == undefined) && !this.mulSelectLoading){
        this.$message({
          message: this.$t("runState.select_search_level"),//'请选择汇总级别',
          type: 'warning'
        });
        return ;
      }
      if(this.form.beginDate == "" || this.form.beginDate == null || this.form.beginDate == undefined){
        this.$message({
          message: this.$t("runState.select_search_date"),//'请选择查询时间',
          type: 'warning'
        });
        return ;
      }
      if(this.selectLevel){  // 汇总级别有数据时，进行数据查询。
        this.currentPage = 1;
        if(this.isClicked){
          this.getList();
        }
      }
    },
    download(){
      
      this.vehicles = this.getSelectedVehicles();
      var that = this;
      that.downloading = true;
      this.$api.downSummaryInfo({
        // vehicles: "",
        queryType: this.queryType,
        beginDate: this.form.beginDate,
        endDate: this.form.endDate,
        level: this.selectLevel,
        OperatorID: this.operator.OperatorId + "",
        IsExport: 1, // 0是查询 1是下载
        Language: this.LanguageId,
      })
        .then((res) => {
          var fileName = "";
          if(that.queryType == 0){
            fileName = that.$t("runState.daySummary")+that.$t("public.download");
          }else if(that.queryType == 1){
            fileName = that.$t("runState.monthSummary")+that.$t("public.download");
          }else if(that.queryType == 2) {
            fileName = that.$t("runState.summary")+that.$t("public.download");
          }
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8",
          }); // 重点代码
          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.setAttribute(
            "download",
            fileName + `_${that.timestampToTime(new Date().getTime())}.xlsx`
          ); // 表名，自定义
          a.click(); // 执行下载
          window.URL.revokeObjectURL(blob); // 释放ur
          that.downloading = false;
        })
        .catch((error) => {
          console.error("下载失败", error);
          that.downloading = false;
        });
    },
    //时间戳转换为日期格式
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间数为10位篇*1000，时间数为13位的话不需乘1000
      var Y = date.getFullYear();
      var M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var D = date.getDate();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if(j == "runduration"){
          return this.fixed2(v[j]);
        }else if(j == "driveDuration") {
          return this.fixed2(v[j]);
        }else if(j == "idleDuration") {
          return this.fixed2(v[j]);
        }else if(j == "runMileage") {
          return this.fixed2(v[j]);
        }else if(j == "perElecConsume") {
          return this.fixed2(v[j]);
        }else{
          return v[j]
        }
      }))
    },


    
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 获取表格数据
      const data = this.dataList;
      // 合并 groupName 列
      if (columnIndex === 0) {
        if (rowIndex > 0 && row.groupName === data[rowIndex - 1].groupName) {
          return { rowspan: 0, colspan: 0 };  // 合并当前和上一行的 groupName
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < data.length; i++) {
            if (data[i].groupName === row.groupName) {
              rowspan++;
            } else {
              break;
            }
          }
          return {
            rowspan: rowspan, // 合并的行数
            colspan: 1 // groupName 列合并
          };
        }
      }

      // 其他列的处理
      return {
        rowspan: 1,
        colspan: 1
      };
    },

    getWidth(){
      const body = document.body;
      const html = document.documentElement;
      const width = Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
      switch(this.LanguageId){
        case 1:
          if(this.sidebar_opened){
            console.log(width);
            if(width <= 1418){
              this.search_align_items = "";
              this.search_flex_direction = "column";
            }else{
              this.search_align_items = "center";
              this.search_flex_direction = "row";
            }
          }else{
            this.search_align_items = "center";
              this.search_flex_direction = "row";
          }
          break;
        case 3:
          if(width <= 1572 && !this.sidebar_opened){//1280
              this.search_align_items = "";
              this.search_flex_direction = "column";
          }else if(width <= 1825 && this.sidebar_opened){
              this.search_align_items = "";
              this.search_flex_direction = "column";
          }else{
            this.search_align_items = "center";
            this.search_flex_direction = "row";
          }
          break;
        default:
          if(width <= 1572 && !this.sidebar_opened){//1280
              this.search_align_items = "";
              this.search_flex_direction = "column";
          }else if(width <= 1825 && this.sidebar_opened){
              this.search_align_items = "";
              this.search_flex_direction = "column";
          }else{
            this.search_align_items = "center";
            this.search_flex_direction = "row";
          }
      }
    }
  },
  mounted(){
    this.LanguageId = language(this.$store.getters.locale)
    
    // this.getList();
    window.addEventListener('resize',this.getWidth);
    this.getWidth();
    
  },
  destroyed(){
    window.removeEventListener('resize',this.getWidth);
  }

}
</script>

<style lang="scss" scoped>
.page_container_a {
    margin-top: 10px;

    ::v-deep .el-table tr {
        background: rgb(244, 248, 255);
    }

    ::v-deep .el-table {
        background: rgb(244, 248, 255);
    }

    ::v-deep .el-table td {
        background: rgb(244, 248, 255);
    }
} 
::v-deep .el-table {
  .el-table__body-wrapper {
    z-index: 1;
  }
}

 ::v-deep .el-table__fixed,
 	.el-table__fixed-left {
 		// background: rgb(244, 248, 255)!important;
 		background: rgb(238, 244, 255)!important;
 	}

 	::v-deep .el-table__fixed-right {
 		background-color: #f5f9ff !important;
 	}
// ::v-deep .fixed-pre-first-field {
//         z-index: 4;
//     }
//     ::v-deep .el-table--scrollable-x{
//       .fixed-pre-first-field {
//         z-index: 0;
//       }
//     }
</style>
